import { Fragment, useEffect, useState } from "react";
import { isValidArray } from "../../../Layout/Common/common";
import { toggleSections } from "../scripts";

export const DownloadFileList = ({ params }) => {
  const [filesList, setFileList] = useState(null);

  const handleDownloadFile = async (e, file) => {
    const a = document.createElement("a");
    a.href = file.downloadpath;
    a.target = "_blank";
    a.setAttribute("download", file.filename); // forces download
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  useEffect(() => {
    if (isValidArray(params)) {
      setFileList(params);
    }
  }, [params]);

  return (
    <Fragment>
      {isValidArray(filesList) &&
        filesList.map((item, index) => (
          <div className="col-lg-12" key={index}>
            <div className="download-products">
              <div className="download-products-lft">
                <div>
                  <span className="wes-download" />
                </div>
                <div className="download-products-lftContent">
                  <h5>{item.filedesc}</h5>
                  <p>{item.filesize}</p>
                </div>
              </div>
              <div className="product-button button-effect">
                <button
                  type="submit"
                  className="btn btn-products btn-addcart "
                  onClick={(e) => {
                    handleDownloadFile(e, item);
                  }}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        ))}
    </Fragment>
  );
};
